import { render, staticRenderFns } from "./MaintenanceSummary.vue?vue&type=template&id=88c5a374&scoped=true"
import script from "./MaintenanceSummary.vue?vue&type=script&lang=js"
export * from "./MaintenanceSummary.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceSummary.vue?vue&type=style&index=0&id=88c5a374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c5a374",
  null
  
)

export default component.exports